module.exports = __webpack_public_path__ + "static/media/succes.ceccbdf1.gif";